// spec 260509-system-monitor C-1：桌面右上角"系统监控" 4 段 widget。
//
// 4 段固定结构（design.md §3.1）：
//   ① 健康摘要：OK / WARN / CRIT 徽章 + 主因短句（不做 hysteresis）
//   ② 当前瓶颈：单资源 + 60s 迷你 sparkline（hysteresis 在 hook 里）
//   ③ 模型：主模型完整行 + 次模型折叠行
//   ④ 服务：N/M + 异常服务名
//
// store 由 ``useSystemMetricsStore`` 提供共享数据；启动时 ``startPolling``，
// 卸载时 ``stopPolling``。Dashboard 与 Widget 共享同一份 store，QPS 不会翻倍
// （spec §7 验收 #18）。

import { useEffect } from 'react';
import type { ReactElement } from 'react';

import {
  attachVisibilityHandler,
  useSystemMetricsStore,
} from '../state/system-metrics-store';
import { BottleneckSection } from './sections/BottleneckSection';
import { HealthSummarySection } from './sections/HealthSummarySection';
import { ModelSection } from './sections/ModelSection';
import { ServicesSummarySection } from './sections/ServicesSummarySection';

export function SystemHealthWidget(): ReactElement {
  const startPolling = useSystemMetricsStore((s) => s.startPolling);
  const stopPolling = useSystemMetricsStore((s) => s.stopPolling);

  useEffect(() => {
    startPolling();
    const detachVisibility = attachVisibilityHandler();
    return () => {
      detachVisibility();
      // 注意：widget 是桌面常驻组件；卸载只在登出 / 切壳时。常态下不会触发。
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  return (
    <section className="sysmon-widget" aria-label="系统监控" data-testid="sysmon-widget">
      <HealthSummarySection />
      <BottleneckSection />
      <ModelSection />
      <ServicesSummarySection />
    </section>
  );
}

export default SystemHealthWidget;
